<div [formGroup]="form" class="reservation-pet-tile-form-container">
  <div class="row no-gutters" >
    <div class="col-auto">
      <mat-checkbox
        #tile
        aria-label="selectPet"
        [checked]="isPetSelected"
        (change)="tile.checked !== isPetSelected && togglePetSelected($event)"
        (keyup.enter)="togglePetSelected($event)"
        style="margin-right: 0.625rem"
      ></mat-checkbox>
    </div>
    <div class="col clickable"
         (click)="togglePetSelected($event)"
        >
      <ng-container *ngIf="petInfo">
        <div class="lato bold primary mt-1">
          {{
            petInfo.firstName
              ? petInfo.firstName + " " + petInfo.lastName
              : petInfo.nickName
          }}
        </div>
        <div class="pet-info-table">
          <div class="row no-gutters">
            <div class="pet-info-label">Breed:</div>
            <div class="pet-tile-form-content col">{{ breedNameList }}</div>
          </div>
          <div class="row no-gutters">
            <div class="pet-info-label col-auto pr-2">Weight:</div>
            <div class="pet-tile-form-content col">
              {{ petInfo?.weight?.weight + " lbs" }}
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
